"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCallout = exports.ErrorReading = void 0;
/* eslint-disable energy-cx/nebula-imports */
var nebula_1 = require("@ovotech/nebula");
var styled_components_1 = __importDefault(require("styled-components"));
exports.ErrorReading = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var colors = _a.theme.colors;
    return "\n    color: ".concat(colors.error, ";\n  ");
});
exports.StyledCallout = (0, styled_components_1.default)(nebula_1.Callout)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var space = _a.theme.space;
    return "\n    margin-bottom: ".concat(space[8], ";\n    li {\n      margin: 0;\n    }\n  ");
});
var templateObject_1, templateObject_2;
